import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import HospitalIPDDashboard from 'images/hospital-network-dashboard.png';
export default function HospitalizationDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h5' align='center' mb={2}>{t('hospitalStaydashboardText', { ns: ['home'] })}</Typography>
      <img src={HospitalIPDDashboard} style={{ width: '100vw' }} />
    </Box>
  );
}